<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon class="w-6 h-6">settings</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Stammdaten</h2>
      </div>
    </div>

    <mat-tab-group>

          <!--
              ARTIKEL
          -->
          <mat-tab label="Artikel">
            <div class="mt-6">
              <div class="flex justify-between items-center mb-4">
                <div class="flex items-center space-x-2">
                </div>
                <button mat-raised-button (click)="addNewArtikel()" color="primary" class="flex items-center space-x-2">
                  <mat-icon class="w-4 h-4">add</mat-icon>
                  <span>Neuanlage</span>
                </button>
              </div>
              <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <table mat-table #tableArtikel [dataSource]="dataSourceArtikel" class="w-full">
                  <!-- Nummer Column -->
                  <ng-container matColumnDef="nummer">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nummer</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.nummer }}</td>
                  </ng-container>

                  <!-- Beschreibung Column -->
                  <ng-container matColumnDef="beschreibung">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Beschreibung</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 text-sm text-gray-900">{{ row.beschreibung }}</td>
                  </ng-container>

                  <!-- Art Column -->
                  <ng-container matColumnDef="art">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Art</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.art }}</td>
                  </ng-container>

                  <!-- Basiseinheit Column -->
                  <ng-container matColumnDef="basiseinheit">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Basiseinheit</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.basiseinheit }}</td>
                  </ng-container>

                  <!-- Code Column -->
                  <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Code</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.code }}</td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktionen</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm font-medium">
                      <button mat-icon-button (click)="editItem('Artikel', row)" aria-label="Edit" class="text-blue-600 hover:text-blue-900">
                        <mat-icon class="w-4 h-4">edit</mat-icon>
                      </button>
                      <button mat-icon-button (click)="removeItem('Artikel', row)" aria-label="Delete" class="text-red-600 hover:text-red-900 ml-1">
                        <mat-icon class="w-4 h-4">delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayArtikel" class="bg-gray-50"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayArtikel" (dblclick)="editItem('Artikel', row)" class="hover:bg-gray-50 cursor-pointer"></tr>
                </table>
              </div>
            </div>
          </mat-tab>

          <!--
              MASSNAHMEN
          -->
          <mat-tab label="Maßnahmen">
            <div class="mt-6">
              <div class="flex justify-between items-center mb-4">
                <div class="flex items-center space-x-2">
                </div>
                <button mat-raised-button (click)="addNewMassnahme()" color="primary" class="flex items-center space-x-2">
                  <mat-icon class="w-4 h-4">add</mat-icon>
                  <span>Neuanlage</span>
                </button>
              </div>
              <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <table mat-table #tableMassnahme [dataSource]="dataSourceMassnahme" class="w-full">
                  <!-- Beschreibung Column -->
                  <ng-container matColumnDef="beschreibung">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Beschreibung</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 text-sm text-gray-900">{{ row.beschreibung }}</td>
                  </ng-container>

                  <!-- Druck auf Bericht Column -->
                  <ng-container matColumnDef="druck_auf_bericht">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Druck auf Bericht</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                      <span [class]="row.druck_auf_bericht ? 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800' : 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800'">
                        {{ row.druck_auf_bericht ? 'Ja' : 'Nein' }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Foto erforderlich Column -->
                  <ng-container matColumnDef="foto_erforderlich">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Foto erforderlich</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                      <span [class]="row.foto_erforderlich ? 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800' : 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800'">
                        {{ row.foto_erforderlich ? 'Ja' : 'Nein' }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Sortierung Column -->
                  <ng-container matColumnDef="sortierung">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sortierung</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.sortierung }}</td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktionen</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm font-medium">
                      <button mat-icon-button (click)="editItem('Massnahme', row)" aria-label="Edit" class="text-blue-600 hover:text-blue-900">
                        <mat-icon class="w-4 h-4">edit</mat-icon>
                      </button>
                      <button mat-icon-button (click)="removeItem('Massnahme', row)" aria-label="Delete" class="text-red-600 hover:text-red-900 ml-1">
                        <mat-icon class="w-4 h-4">delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayMassnahme" class="bg-gray-50"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayMassnahme" (dblclick)="editItem('Massnahme', row)" class="hover:bg-gray-50 cursor-pointer"></tr>
                </table>
              </div>
            </div>
          </mat-tab>

          <!--
              ABWEICHUNGEN
          -->
          <mat-tab label="Abweichungen">
            <div class="mt-6">
              <div class="flex justify-between items-center mb-4">
                <div class="flex items-center space-x-2">
                </div>
                <button mat-raised-button (click)="addNewAbweichung()" color="primary" class="flex items-center space-x-2">
                  <mat-icon class="w-4 h-4">add</mat-icon>
                  <span>Neuanlage</span>
                </button>
              </div>
              <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <table mat-table #tableAbweichung [dataSource]="dataSourceAbweichung" class="w-full">
                  <!-- Caption Column -->
                  <ng-container matColumnDef="caption">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Titel</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 text-sm font-medium text-gray-900">{{ row.caption }}</td>
                  </ng-container>

                  <!-- Description Column -->
                  <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Beschreibung</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 text-sm text-gray-900">{{ row.description | slice:0:100 }}{{ row.description.length > 100 ? '...' : '' }}</td>
                  </ng-container>

                  <!-- Status Column -->
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">
                      <span [class]="row.status === 'active' ? 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800' : 'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800'">
                        {{ row.status === 'active' ? 'Aktiv' : 'Inaktiv' }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Sortierung Column -->
                  <ng-container matColumnDef="sortierung">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sortierung</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{{ row.sortierung }}</td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktionen</th>
                    <td mat-cell *matCellDef="let row" class="px-3 py-2 whitespace-nowrap text-sm font-medium">
                      <button mat-icon-button (click)="editItem('Abweichung', row)" aria-label="Edit" class="text-blue-600 hover:text-blue-900">
                        <mat-icon class="w-4 h-4">edit</mat-icon>
                      </button>
                      <button mat-icon-button (click)="removeItem('Abweichung', row)" aria-label="Delete" class="text-red-600 hover:text-red-900 ml-1">
                        <mat-icon class="w-4 h-4">delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayAbweichung" class="bg-gray-50"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayAbweichung" (dblclick)="editItem('Abweichung', row)" class="hover:bg-gray-50 cursor-pointer"></tr>
                </table>
              </div>
            </div>
          </mat-tab>
    </mat-tab-group>
  </div>
</div>